











import { Component, Vue, Prop } from 'vue-property-decorator';

import TitleOnboarding from '@/components/molecules/TitleOnboarding/TitleOnboarding.vue';
import ManageRewards from '@/components/organisms/ManageRewards/ManageRewards.vue';

@Component({
  components: {
    TitleOnboarding,
    ManageRewards
  }
})
export default class ManageLoyalty extends Vue {
  @Prop({ default: false }) readonly page?: boolean;

  onSave() {
    this.$notification('Loyalty set up successfully', 'success');
  }
}
